import {handleAction, handleSubState} from 'uix/actions'
import log from 'uix/logging'

export const data = [
  handleSubState(
    'vlm',
    [
      handleAction('SET_TO_VLM_STATE', ({to, ...vlm}, {payload}) => ({
        ...vlm,
        to: {...to, [payload.name]: payload.value},
      })),
      handleAction('SET_FROM_VLM_STATE', ({from, ...vlm}, {payload}) => ({
        ...vlm,
        from: {...from, [payload.name]: payload.value},
      })),
    ],
    {to: {}, from: {}}
  ),
]
